import React, { useState } from "react";
import "../styles/EmailModal.css";

interface EmailModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (email: string) => Promise<void>;
}

const EmailModal: React.FC<EmailModalProps> = ({ isOpen, onClose, onSubmit }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      setError("Please enter a valid email address");
      return;
    }

    setLoading(true);
    try {
      await onSubmit(email);
      setSuccess(true);
      setEmail("");
      setTimeout(() => {
        setSuccess(false);
        onClose();
      }, 2000);
    } catch (err) {
      setError("Failed to save email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="email-modal-overlay" onClick={onClose}>
      <div className="email-modal" onClick={(e) => e.stopPropagation()}>
        <button className="email-modal-close" onClick={onClose}>
          ×
        </button>
        {success ? (
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h2>Success!</h2>
            <p>Your download is starting. Check your downloads folder.</p>
          </div>
        ) : (
          <>
            <h2>Download Report</h2>
            <p>Enter your email to download the 2025 Impact Report</p>
            <form onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                required
              />
              {error && <p className="error-message">{error}</p>}
              <button type="submit" disabled={loading}>
                {loading ? "Processing..." : "Download"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default EmailModal;
